import './modal.css';

const Modal = ({ handleClose, show, children }) => {
    const showHide = show ? "modal display-block" : "modal display-none";

    return (
        <div className={showHide}>
            <section className="modal-main">
                {children}
                <button type="button" onClick={handleClose} className="close">
                    Close
                </button>
            </section>
        </div>
    );
}

export default Modal;